export const TYPE_PRODUCT_LIST_REQUEST = "TYPE_PRODUCT_LIST_REQUEST";
export const TYPE_PRODUCT_LIST_SUCCESS = "TYPE_PRODUCT_LIST_SUCCESS";
export const TYPE_PRODUCT_LIST_FAIL = "TYPE_PRODUCT_LIST_FAIL";

export const TYPE_PRODUCT_DELETE_REQUEST = "TYPE_PRODUCT_DELETE_REQUEST";
export const TYPE_PRODUCT_DELETE_SUCCESS = "TYPE_PRODUCT_DELETE_SUCCESS";
export const TYPE_PRODUCT_DELETE_FAIL = "TYPE_PRODUCT_DELETE_FAIL";
